import { render } from "./ModalEditarSite.vue?vue&type=template&id=6ed5d4e4&ts=true"
import script from "./ModalEditarSite.vue?vue&type=script&lang=ts"
export * from "./ModalEditarSite.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__